import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';
import * as moment from "moment";

moment.locale('pt-BR');

interface PeriodoPedidoMultiloja {
    Id: string;
    DataEmissao: Date;
    QuantidadePedido: number;
    QuantidadePeca: number;
    ValorLiquido: number;
    PrecoMedio: number;
    Empresa: Empresa;
}

@Component({
    selector: 'periodo-ped-multilojas',
    templateUrl: './periodo-ped-multilojas.html'
})
export class PeriodoPedidoMultilojasComponent implements OnInit, OnDestroy {
    public hoje: string = new Date().toISOString();
    public dataInicial: string = new Date("2012-01-01").toISOString();
    public dataFinal: string = new Date().toISOString();

    @Input('analytic') analytic: boolean = false;

    public pedidoMultilojaDilady: any;
    public pedidoMultilojaLoveSecret: any;
    public pedidoMultilojaBanhoDeMar: any;
    public pedidoMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this.carregandoDados = true;
        this._separarLojas();

        if (this._myInterval)
            clearInterval(this._myInterval);

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterPeriodoPedidoMultiloja().then(periodosBruto => {
            let periodos = periodosBruto.filter(a => moment(a.DataEmissao).isBetween(this.dataInicial, this.dataFinal));

            this.pedidoMultilojaGrupo = {
                QuantidadePedido: _.sum(periodos.map(a => a.QuantidadePedido)),
                QuantidadePeca: _.sum(periodos.map(a => a.QuantidadePeca)),
                ValorLiquido: _.sum(periodos.map(a => a.ValorLiquido))
            }
            this.pedidoMultilojaGrupo.PrecoMedio = (this.pedidoMultilojaGrupo.ValorLiquido / this.pedidoMultilojaGrupo.QuantidadePeca);

            let pedidoMultilojaDilady = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 1));
            if (pedidoMultilojaDilady.length > 0) {
                this.pedidoMultilojaDilady = {
                    QuantidadePedido: _.sum(pedidoMultilojaDilady.map(a => a.QuantidadePedido)),
                    QuantidadePeca: _.sum(pedidoMultilojaDilady.map(a => a.QuantidadePeca)),
                    ValorLiquido: _.sum(pedidoMultilojaDilady.map(a => a.ValorLiquido)),
                    Empresa: pedidoMultilojaDilady[0].Empresa
                }
                this.pedidoMultilojaDilady.PrecoMedio = (this.pedidoMultilojaDilady.ValorLiquido / this.pedidoMultilojaDilady.QuantidadePeca);
            } else {
                this.pedidoMultilojaDilady = {
                    QuantidadePedido: 0,
                    QuantidadePeca: 0,
                    ValorLiquido: 0,
                    PrecoMedio: 0,
                    Empresa: { Id: 1, Descricao: 'Dilady Lingerie' }
                }
            }

            let pedidoMultilojaLoveSecret = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 2));
            if (pedidoMultilojaLoveSecret.length > 0) {
                this.pedidoMultilojaLoveSecret = {
                    QuantidadePedido: _.sum(pedidoMultilojaLoveSecret.map(a => a.QuantidadePedido)),
                    QuantidadePeca: _.sum(pedidoMultilojaLoveSecret.map(a => a.QuantidadePeca)),
                    ValorLiquido: _.sum(pedidoMultilojaLoveSecret.map(a => a.ValorLiquido)),
                    Empresa: pedidoMultilojaLoveSecret[0].Empresa
                }
                this.pedidoMultilojaLoveSecret.PrecoMedio = (this.pedidoMultilojaLoveSecret.ValorLiquido / this.pedidoMultilojaLoveSecret.QuantidadePeca);
            } else {
                this.pedidoMultilojaLoveSecret = {
                    QuantidadePedido: 0,
                    QuantidadePeca: 0,
                    ValorLiquido: 0,
                    PrecoMedio: 0,
                    Empresa: { Id: 2, Descricao: 'Love Secret Lingerie' }
                }
            }

            let pedidoMultilojaBanhoDeMar = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 3));
            if (pedidoMultilojaBanhoDeMar.length > 0) {
                this.pedidoMultilojaBanhoDeMar = {
                    QuantidadePedido: _.sum(pedidoMultilojaBanhoDeMar.map(a => a.QuantidadePedido)),
                    QuantidadePeca: _.sum(pedidoMultilojaBanhoDeMar.map(a => a.QuantidadePeca)),
                    ValorLiquido: _.sum(pedidoMultilojaBanhoDeMar.map(a => a.ValorLiquido)),
                    Empresa: pedidoMultilojaBanhoDeMar[0].Empresa
                }
                this.pedidoMultilojaBanhoDeMar.PrecoMedio = (this.pedidoMultilojaBanhoDeMar.ValorLiquido / this.pedidoMultilojaBanhoDeMar.QuantidadePeca);
            } else {
                this.pedidoMultilojaBanhoDeMar = {
                    QuantidadePedido: 0,
                    QuantidadePeca: 0,
                    ValorLiquido: 0,
                    PrecoMedio: 0,
                    Empresa: { Id: 3, Descricao: 'Banho de Mar Acquashape' }
                }
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterPeriodoPedidoMultiloja(): Promise<PeriodoPedidoMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('PeriodoPedidoMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/periodo-ped-multilojas/periodo-ped-multilojas.ts